import React from "react"

import loaderIcon from "assets/svg/loader.svg"

import styles from "./styles.css"

const Loader = () => {
  return (
    <div className={styles.root}>
      <img src={loaderIcon} />
    </div>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/Loader/index.js